import { ColorSelectorSubmenuAsMenuItem } from "./ColorSelectorSubmenu";
import Menu, { MenuProps } from "./Menu";
import { MenuButtonAsMenuItem } from "./MenuButton";
import { MenuColorSelectorAsMenuItem } from "./MenuColorSelector";
import { DividerAsMenuItem } from "./MenuDivider";
import { MenuLinkAsMenuItem } from "./MenuLink";
import { MultiSelectSubmenuAsMenuItem } from "./MultiSelectSubmenu";
import OverlayMenu from "./OverlayMenu";
import { SingleSelectSubmenuAsMenuItem } from "./SingleSelectSubmenu";
import { SubmenuAsMenuItem } from "./Submenu";

type ExtendedMenu = typeof Menu & {
    Submenu: typeof SubmenuAsMenuItem;
    MultiSelectSubmenu: typeof MultiSelectSubmenuAsMenuItem;
    SingleSelectSubmenu: typeof SingleSelectSubmenuAsMenuItem;
    ColorSelectorSubmenu: typeof ColorSelectorSubmenuAsMenuItem;
    ColorSelector: typeof MenuColorSelectorAsMenuItem;
    Button: typeof MenuButtonAsMenuItem;
    Link: typeof MenuLinkAsMenuItem;
    Overlay: typeof OverlayMenu;
    Divider: typeof DividerAsMenuItem;
};

const MenuWithItems: ExtendedMenu = Menu as ExtendedMenu;
MenuWithItems.Submenu = SubmenuAsMenuItem;
MenuWithItems.MultiSelectSubmenu = MultiSelectSubmenuAsMenuItem;
MenuWithItems.SingleSelectSubmenu = SingleSelectSubmenuAsMenuItem;
MenuWithItems.ColorSelectorSubmenu = ColorSelectorSubmenuAsMenuItem;
MenuWithItems.ColorSelector = MenuColorSelectorAsMenuItem;
MenuWithItems.Button = MenuButtonAsMenuItem;
MenuWithItems.Link = MenuLinkAsMenuItem;
MenuWithItems.Overlay = OverlayMenu;
MenuWithItems.Divider = DividerAsMenuItem;

export default MenuWithItems;
export {
    MenuProps
};
